// extracted by mini-css-extract-plugin
module.exports = {"buttonSelector":"button-select_buttonSelector__1uzmR","selected":"button-select_selected__2CF4h"};